import type { DocumentAssetDto } from "@xs2event/js-lib/api";
import { api } from "./api";

export const startDownload = (url, filename) => {
  const link = document.createElement("a");
  link.download = filename;
  if (filename) {
    link.download = filename;
  }
  link.href = url;
  link.target = "_blank";
  document.body.append(link);
  link.click();
};

export const downloadDocumentAsset = async (asset: DocumentAssetDto) => {
  if (!asset?.documentassetId) return;

  try {
    const res = await api.get(`documentassets/download/${asset.documentassetId}`, {
      responseType: "blob",
    });

    const blobUrl = window.URL.createObjectURL(res.data);
    startDownload(blobUrl, `xs2event-document-${asset.filename}`);
    window.setTimeout(() => window.URL.revokeObjectURL(blobUrl), 10_000);
  } catch (err: unknown) {
    const message = err instanceof Error ? err.message : String(err);
    alert(message);
  }
};
